"use client"

import { HttpTypes } from "@medusajs/types"

import { Chip } from "@/components/atoms"
import useUpdateSearchParams from "@/hooks/useUpdateSearchParams"
import { BaseHit, Hit } from "instantsearch.js"

export const ProductVariants = ({
  product,
  selectedVariant,
}: {
  product: HttpTypes.StoreProduct
  selectedVariant: Record<string, string>
}) => {
  const updateSearchParams = useUpdateSearchParams()

  // update the options when a variant is selected
  const setOptionValue = (optionId: string, value: string) => {
    if (value) updateSearchParams(optionId, value)
  }

  return (
    <div className="py-4 space-y-2">
      {(product.options || []).map(
        ({ id, title, values }: HttpTypes.StoreProductOption) => (
          <div key={id}>
            <span className="label-md text-secondary">{title}: </span>
            <span className="label-md text-primary">
              {selectedVariant[title.toLowerCase()]}
            </span>
            <div className="flex flex-row flex-wrap gap-2 mt-2">
              {(values || []).map(
                ({
                  id,
                  value,
                }: Partial<Hit<HttpTypes.StoreProductOptionValue>>) => (
                  <Chip
                    key={id}
                    selected={selectedVariant[title.toLowerCase()] === value}
                    color={title === "Color"}
                    value={value}
                    onSelect={() =>
                      setOptionValue(title.toLowerCase(), value || "")
                    }
                    className={"text-center justify-center align-middle " + (title === "Color" ? '' : 'min-w-16')}
                  />
                )
              )}
            </div>
          </div>
        )
      )}
    </div>
  )
}
